module.exports = __webpack_public_path__ + "static/media/error_maintenance.64c47f85.png";